import { $get, empty } from '@makeabledk/vue-ui/support/helpers'
import resolve from 'tailwindcss/resolveConfig'

let config

export default class Tailwind {
    static load(customConfig) {
        config = resolve(customConfig)
    }

    static config(key, _default = null) {
        if (empty(config)) {
            throw new Error('Tailwind config not loaded! Please use TailwindProvider.load() in your bootstrap file')
        }

        return $get(config, key, _default)
    }

    static color(color) {
        return color.startsWith('#') ? color : this.config(`theme.colors.${color}`)
    }
}
